import { capitalize } from '@material-ui/core';

import { DATA_TEST_ATTRIBUTE } from '@core/config';
import { OfferAttributeEnum } from '@gqlTypes/globalTypes';

import { ObjectType, RefHook } from './types';

const k = 1024;
const sizes = ['Bajtów', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) {
    return '0 Bajtów';
  }

  const dm = decimals < 0 ? 0 : decimals;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const camalize = (str: string) =>
  str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());

export const getAttrByType = <A extends object>(
  attributes: Array<A & { type: OfferAttributeEnum }>,
  type: OfferAttributeEnum,
): A | undefined => attributes.find((attr) => attr.type === type);

export function getAttrBySlug<Attr extends Record<string, any>>(
  attributes: Array<Attr & { slug: string }>,
  slug: string,
): Attr | undefined {
  return attributes.find((attr) => attr.slug === slug);
}

export const setBrowserCredentials = ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  if (webCredentialsAPI()) {
    navigator.credentials.store(new window.PasswordCredential({ id: email, password }));
  }
};

export const googleDocsPreviewUrl = (url: string) => `https://docs.google.com/viewer?url=${url}`;

export const objectDeepKeys = <T extends { [key: string]: any }>(obj: T): string[] =>
  Object.keys(obj)
    .filter((key) => obj[key] instanceof Object)
    .map((key) => objectDeepKeys(obj[key]).map((k) => `${key}.${k}`))
    .reduce((x, y) => x.concat(y), Object.keys(obj));

export const isBlankObj = (obj: Record<string, never>) =>
  !Object.values(obj).filter((v) => v).length;

export const webCredentialsAPI = () =>
  !!(
    window.PasswordCredential &&
    window.FederatedCredential &&
    window.PublicKeyCredential &&
    navigator.credentials
  );

export const scroll = ({ ref, top = 0 }: { ref?: RefHook; top?: number }) => {
  const scroll = window.scrollTo || window.scrollBy || window.scroll;
  scroll({
    behavior: 'smooth',
    top: ref?.current ? ref.current.offsetTop : top,
  });
};

/**
 * @param name - follow convention: typeActionExtraInformation, like buttonLogin, linkLogout
 * @param prefix - checkout, payment etc
 */
export const getTestAttribute = (
  name: string | undefined | null,
  prefix = '',
): ObjectType<string> => {
  // Fail-safe: MUI capitalize requires a string, guard against undefined/null/non-string
  const safeName = typeof name === 'string' && name ? name : '';
  const safePrefix = typeof prefix === 'string' ? prefix : '';
  return {
    [DATA_TEST_ATTRIBUTE]: safeName ? `${safePrefix}${capitalize(safeName)}` : '',
  };
};
